import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";

import { FieldsSetting } from "../../../actions";
import { FIELDS } from "../../../constants";
import MappedFieldsList from "./MappedFieldsList";
import CSV_EMPTY_SCREEN from "../../../assets/csv_empty_screen.png";
import { getTriggerDetailsAction } from "../../../actions/FieldsSetting/fieldsSettingActions";
import LZLoader from "../../../commonComponents/LZLoader";

const { updateCurrentSelectedObject, nukeSyncDataSourceFlags } = FieldsSetting;

const FieldsMapper = ({
  dsObjects,
  sourceObjSchema,
  dataSourceSelected,
  currentSelectedObject,
  initFieldsMappingData,
  templateId,
  loadingMessage,
  showMenuType,
  showMenu,
  tableIdsList,
  signerIDsList,
  searchInput,
  filterState,
  revvFieldIDsList,
  metaFieldIDsList,
  // csvData,
  showCSVFields,
  getTriggers,
}) => {
  useEffect(() => {
    if (
      !(dataSourceSelected && currentSelectedObject) &&
      dataSourceSelected !== "csv"
    )
      initFieldsMappingData(dataSourceSelected);
    getTriggers(templateId);
  }, [
    initFieldsMappingData,
    dataSourceSelected,
    currentSelectedObject,
    getTriggers,
    templateId,
  ]);

  const currObj = dsObjects.find(obj => obj.name === currentSelectedObject);

  if (!currObj && dataSourceSelected !== "csv") {
    return null;
  }

  if (dataSourceSelected === "csv" && !showCSVFields) {
    return (
      <div className="sf-empty-csv-screen">
        <img className="sf-csv-img" src={CSV_EMPTY_SCREEN} alt="Revv" />
        <div className="sf-csv-emptyscreen-text">
          <span>
            Upload CSV file and click on{" "}
            <strong>
              <i>Sync fields</i>
            </strong>{" "}
            once you are done.
          </span>
        </div>
      </div>
    );
  }

  const dataSource = FIELDS.DATA_SOURCES.find(
    source => source.name === dataSourceSelected,
  );

  return (
    <div className="assigned-sf-fieldsmapper-body">
      {(currentSelectedObject &&
        sourceObjSchema &&
        sourceObjSchema[currentSelectedObject]) ||
      dataSourceSelected === "csv" ? (
        <div>
          {" "}
          {Array.isArray(revvFieldIDsList) && revvFieldIDsList.length > 0 && (
            <div className="assigned-sf-fieldsmapper-container">
              <div className="col-md-12 sfi-mapper-section">
                <div className="sf-mapper-container">
                  <Fragment>
                    <MappedFieldsList
                      templateId={templateId}
                      currentObject={currObj}
                      currentDataSource={dataSource}
                      showMenuType={showMenuType}
                      showMenu={showMenu}
                      searchInput={searchInput}
                      filterState={filterState}
                      cardName="FORM"
                      value="FORM"
                    />
                  </Fragment>
                </div>
              </div>
            </div>
          )}
          {signerIDsList &&
            signerIDsList.length > 0 &&
            signerIDsList.map((value, i) => (
              <div className="assigned-sf-fieldsmapper-container">
                <div className="col-md-12 sfi-mapper-section">
                  <div className="sf-mapper-container">
                    <Fragment>
                      <MappedFieldsList
                        templateId={templateId}
                        currentObject={currObj}
                        currentDataSource={dataSource}
                        showMenuType={showMenuType}
                        showMenu={showMenu}
                        value={value}
                        index={i}
                        searchInput={searchInput}
                        filterState={filterState}
                        cardName="SIGNATURE"
                      />
                    </Fragment>
                  </div>
                </div>
              </div>
            ))}
          {tableIdsList &&
            tableIdsList.length > 0 &&
            tableIdsList.map((value, i) => (
              <div
                className={`assigned-sf-fieldsmapper-container ${
                  dataSourceSelected === "csv"
                    ? "assigned-sf-fields-container-disabled"
                    : ""
                }`}>
                <div className="col-md-12 sfi-mapper-section">
                  <div className="sf-mapper-container">
                    <Fragment>
                      <MappedFieldsList
                        templateId={templateId}
                        currentObject={currObj}
                        currentDataSource={dataSource}
                        showMenuType={showMenuType}
                        showMenu={showMenu}
                        value={value}
                        index={i}
                        searchInput={searchInput}
                        filterState={filterState}
                        cardName="TABLE"
                      />
                    </Fragment>
                  </div>
                </div>
              </div>
            ))}
          {Array.isArray(metaFieldIDsList) && metaFieldIDsList.length > 0 && (
            <div className="assigned-sf-fieldsmapper-container">
              <div className="col-md-12 sfi-mapper-section">
                <div className="sf-mapper-container">
                  <Fragment>
                    <MappedFieldsList
                      templateId={templateId}
                      currentObject={currObj}
                      currentDataSource={dataSource}
                      showMenuType={showMenuType}
                      showMenu={showMenu}
                      searchInput={searchInput}
                      filterState={filterState}
                      cardName="META_FIELD"
                    />
                  </Fragment>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <LZLoader label={loadingMessage} />
      )}
    </div>
  );
};
const mapStateToProps = ({
  FieldsSettingStore: {
    dsObjects,
    dataSourceSelected,
    currentSelectedObject,
    objectFieldsMapping,
    sourceObjSchema,
    syncDataSource,
    tableIdsList,
    signerIDsList,
    revvFieldIDsList,
    metaFieldIDsList,
    // csvData,
  },
}) => ({
  dsObjects,
  sourceObjSchema,
  dataSourceSelected,
  objectFieldsMapping,
  currentSelectedObject,
  syncDataSource,
  tableIdsList,
  signerIDsList,
  revvFieldIDsList,
  metaFieldIDsList,
  // csvData,
});

const mapDispatchToProps = {
  updateCurrObj: updateCurrentSelectedObject,
  nukeDataSource: nukeSyncDataSourceFlags,
  getTriggers: getTriggerDetailsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(FieldsMapper);
